import cn from "classnames";
import type { CSSProperties, FC, HTMLAttributes } from "react";
import "../common/Loader.css";

type SkeletonProps = {
	width?: CSSProperties["width"];
	height?: CSSProperties["height"];
	circle?: boolean;
} & HTMLAttributes<HTMLSpanElement>;

export const Skeleton: FC<SkeletonProps> = ({
	width,
	height,
	circle,
	className,
	style,
	...rest
}) => (
	<span
		className={cn("moxie-skeleton", className)}
		style={{
			width,
			height,
			borderRadius: circle ? "999px" : undefined,
			...style,
		}}
		aria-hidden="true"
		{...rest}
	/>
);
